import styled from 'styled-components';
import { breakpoints } from 'styles';
import { isConstruction } from 'config';

export const CardContainer = styled.div`
  max-width: 800px;
  margin: 0 auto;
`;

export const Form = styled.form`
  width: 100%;
  text-align: center;
`;

export const BackgroundContainer = styled.div`
  width: 100%;
  min-height: 100%;
  display: flex;
  overflow-y: scroll;
  flex-direction: column;
  background: linear-gradient(#f4f4f3, #ffffff 512px);
  padding: 32px 36px;

  @media (max-width: ${breakpoints.l}px) {
    padding: 16px;
  }
`;

export const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  div {
    margin: 0;
  }
  h4 {
    margin: 0;
  }
  > button {
    margin-right: 8px;
  }
`;

export const Type = styled.p`
  font-size: 18px;
  line-height: 20px;
  font-family: ${({ theme }) => theme.fontFamily};
  text-transform: ${isConstruction ? 'uppercase' : 'capitalize'};
  color: ${({ theme }) => theme.colors[isConstruction ? 'grey4' : 'grey6']};
  font-weight: ${isConstruction ? 'bold' : 'regular'};
  margin: 24px 0 4px;
`;

export const PageContainer = styled.div`
  width: 100%;
  max-width: 800px;
  margin: 0 auto;

  h1 {
    font-size: 44px;
    line-height: 48px;
  }
`;

export const Description = styled.p`
  width: 100%;
`;

export const Section = styled.div`
  padding: 24px 0;

  h2 {
    text-transform: ${isConstruction ? 'uppercase' : 'initial'};
    margin-bottom: ${isConstruction ? '16px' : '8px'};
  }
`;

export const ReceiptNotice = styled.div`
  margin-bottom: 48px;
  font-style: italic;
  font-family: ${({ theme }) => theme.fontFamily};
  color: ${({ theme }) => theme.colors.grey6};

  @media (max-width: ${breakpoints.s}px) {
    text-align: left;
  }
`;
